<template>
    <div>
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-2">
          <label :for="id" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
            {{label}}
          </label>
          <div class="mt-1 sm:mt-0 sm:col-span-2">
              <input class="text-md" type="file" id="file" :accept="acceptedTypes"  @change="onChangeFile"/>

              <div v-if="error">
                <p v-if="!isMultiError" class="mt-2 text-xs text-red-600 whitespace-pre-wrap" :id="id+'-error'">{{ error }}</p>
                <div v-if="isMultiError">
                  <p v-for="cerror, idx in error" :key="idx" class="mt-2 text-sm text-red-600" :id="id+'-error'">{{cerror}}</p>
                </div>
              </div>
          </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
//      ExclamationCircleIcon
    },
    computed: {
      hasSlot: function() {
        return this.$slots.default;
      },
      isMultiError: function() {
        return this.error && Array.isArray(this.error)
      },
      acceptedTypes: function() {
        if (!this.accept) return "application/pdf"
        else return this.accept
      }
    },
    props: [
        'id',
        'label',
        'error',
        'type',
        'placeholder',
        'modelValue',
        'pre',
        'readonly',
        'small',
        'accept'
    ],
    methods: {
        onChangeFile: function(e) {
            if (e.target.files.length == 0) {
                return;
            }

            const f = e.target.files[0];
            this.$emit('update:modelValue', f) 
        }
    }
};
</script>